import { Buffer } from 'buffer'
import * as Sentry from '@sentry/vue'
import { createGtm } from '@gtm-support/vue-gtm'
import { MotionPlugin } from '@vueuse/motion'
import BigNumber from 'bignumber.js'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import App from './App.vue'
import { BIG_NUMBER_DECIMAL } from './const'
import { i18n } from './plugins/i18n'
import router from './router'
import packageJson from '../package.json'

import 'wepin-vue-component/src/styles/reset.css'
import 'wepin-vue-component/dist/style.css'
import 'wepin-vue-component/src/assets/font/SUIT-Variable.css'
import 'wowerlay/dist/style.css'
import '@/utils/changeCoingeckoHttpGet'

window.Buffer = Buffer
globalThis.Buffer = Buffer
BigNumber.config({ DECIMAL_PLACES: BIG_NUMBER_DECIMAL, EXPONENTIAL_AT: 30 })

const app = createApp(App)
const pinia = createPinia()
// Sentry 초기화 (app.mount 전에)
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_DEPLOY_ENV || import.meta.env.MODE,
    release: `web-wallet@${packageJson.version}`,

    integrations: [
      Sentry.breadcrumbsIntegration({
        console: true,
        dom: true,
        fetch: true,
        history: true,
        xhr: true,
      }),
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: true,
      }),
    ],

    // 환경별 샘플링 레이트 (환경변수로 관리)
    tracesSampleRate: parseFloat(
      import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || '1.0',
    ),
    replaysSessionSampleRate: parseFloat(
      import.meta.env.VITE_SENTRY_SESSION_SAMPLE_RATE || '0.1',
    ),
    replaysOnErrorSampleRate: 1.0, // 에러 발생 시 항상 100%

    // trace 전파 대상 (coingecko-cache는 CORS 이슈로 제외)
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/(?!coingecko-cache\.).*\.wepin\.io/,
    ],
  })
}

app.use(i18n)
app.use(pinia)
app.use(router)
app.use(MotionPlugin)
app.mount('#app')

if (import.meta.env.VITE_DEPLOY_ENV === 'production') {
  app.use(
    createGtm({
      id: 'GTM-5KCVSHJ',
      vueRouter: router,
    }),
  )
}
